<template>
    <div v-if="showPopup" class="m_overlay">
        <button type="button" class="m_close" @click="close"></button>
        <iframe v-if="videoUrl" :src="videoUrl" frameborder="0" allowfullscreen allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"></iframe>
    </div>
</template>

<script>
    export default {
        name: 'VideoPopup',
        props: {
            videoUrl: String
        },
        data: function () {
            return {
                
            }
        },
        methods: {
            close() {
                this.$emit('onClose')
            },
        },
        computed: {
            showPopup() {
                return this.videoUrl ? true : false;
            },           
        },
    }
</script>

<style scoped>
    .m_overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        z-index: 250;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: auto;
    }

    .m_overlay .m_close {
        position: absolute;
        top: 0;
        right: 0;
        margin: 10px;
        padding: 0;
        width: 45px;
        height: 45px;
        background-color: #000;
        color: #fff;
        font-size: 32px;
        border: 2px solid #fff;
        border-radius: 50%;
        cursor: pointer;
        z-index: 350;
    }

    .m_overlay .m_close::before {
        content: "x";
        display: block;
        width: 100%;
        height: 100%;
        font-size: 32px;
        line-height: 32px;
    }

    .m_overlay iframe {
        width: 800px;
        height: 450px;
        max-width: 100%;
        max-height: calc((100vw - 40px) / (16/9));
    }
</style>